import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface TransitProps {
  transitId: string;
  houseConsignmentIndex: number;
  transitName: string;
}

export const useDownloadHouseConsignmentItems = () => {
  return useMutation({
    mutationFn: async ({ transitId, houseConsignmentIndex, transitName }: TransitProps) => {
      const response = await request({
        path: `transits/${transitId}/${houseConsignmentIndex}/download-house-consignment-items`,
        method: 'GET',
        authenticate: true,
        responseType: 'arraybuffer',
      });

      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${transitName}-houseConsignment-${houseConsignmentIndex}.xlsx`);
      document.body.appendChild(link);
      link.click();
    },
    onSuccess: () => {
      toast.success('Successfully downloaded the list!');
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading the house consignment items!`);
    },
  });
};
